
if ( document.querySelectorAll("[data-product-filter]").length > 0 ) {

  // Selektoren
  const productfilter = document.querySelectorAll("[data-product-filter]");
  const productLogo = document.querySelectorAll(".logo--item");

  const selectElement = document.querySelector(".produkte--content-buttons");
  const calDropdown = document.querySelector(".calendar--months");
  const calMonth = document.querySelectorAll(".calendar--month");



  //Funktionen
  const eventListenerActive = el => {
    el.addEventListener("click", () => el.classList.toggle("active"));
  };

  eventListenerActive(selectElement);
  eventListenerActive(calDropdown);

  const filterLogos = (el, target) => {
    const selector = el.dataset.productFilter;
    productfilter.forEach(f => f.classList.remove("active"));
    el.classList.add("active");

    target.forEach(t =>
      t.classList.contains(selector)
        ? (t.classList.add("active"))
        : (t.classList.remove("active"))
    );
  };

  productfilter.forEach(btn =>
    btn.addEventListener("click", () => filterLogos(btn, productLogo))
  );
}
